import React from "react";
import { Link } from "react-router-dom";
import {
    Typography,
    Card,
    CardContent,
    CardHeader,
    CardMedia,
    CardActions,
    Tooltip,
    CardActionArea,
    Box,
} from "@mui/material";

import ListItemMenu from "../../../Common/ListItemMenu";
import { formatBytes } from "../../../../utilities/formatters";
import ResourceAvatar from "./ResourceAvatar";
import DownloadButton from "../../../Common/Button/DownloadButton";
import RenderDate from "../../../Common/Date/RenderDate";

import { getPlaceholderImage } from "../../../Common/Media/MediaThumbnail";

function ResourceCard({ resource, onDelete, onEdit, downloadResource }) {
    const title = resource?.title ?? "Resource";
    const date = resource?.createdAt ? (
        <RenderDate date={resource.createdAt} />
    ) : (
        "-"
    );
    const fileSize = formatBytes(resource.fileSize);
    const associationCount = !!resource?.associations?.length
        ? resource.associations.length
        : 0;

    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={
                    <ResourceAvatar
                        fileMimeType={resource.fileMimeType}
                        associationCount={associationCount}
                    />
                }
                action={
                    <ListItemMenu
                        onDelete={!!resource.canDelete && onDelete}
                        onEdit={resource.canUpdate && onEdit}
                    />
                }
                title={
                    <Typography component="h2" className="card-header-title">
                        {title}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {date}
                    </Typography>
                }
            />
            <Tooltip title="View resource" arrow>
                <CardActionArea
                    component={Link}
                    to={`/portfolio/resources/${resource.id}`}
                    centerRipple={true}
                >
                    <CardContent>
                        <CardMedia
                            component="img"
                            height="194"
                            image={getPlaceholderImage(resource?.fileMimeType)}
                            alt={resource.description || resource.title}
                        />
                    </CardContent>
                </CardActionArea>
            </Tooltip>
            <CardContent>
                <Box className="card-content">
                    <Typography
                        component="span"
                        variant="body2"
                        color="textPrimary"
                    >
                        {`${resource.fileName} (${fileSize})`}
                    </Typography>
                </Box>
            </CardContent>
            <CardActions>
                <DownloadButton
                    url={resource.url}
                    filename={resource.fileName}
                    download={downloadResource}
                />
            </CardActions>
        </Card>
    );
}

export default ResourceCard;
